import isSameYear from 'date-fns/isSameYear'
import isSameMonth from 'date-fns/isSameMonth'
import { CARD_PAYMENT_TYPE_IDS, PAYMENT_TYPES, APPLE_PAY_WALLET_PROVIDER_ID } from 'portal-modules/payments/constants/types'
import Api from 'portal-modules/payments/api'
import {
  sortingPaymentMethods,
  filterPaymentMethodByKey
} from 'portal-modules/common/utils/payment-form-utils'

// Keeping this for now
// Sometimes the server sends back an end_date that works
// but sometimes it doesn't
export function findEndDate(value, options) {
  const date = new Date(value * 1000)
  date.setMinutes(date.getMinutes() + date.getTimezoneOffset())
  let endDate = value ? date : value

  return value > 1
    ? options?.find(option => {
      let date = new Date(option * 1000)
      return isSameMonth(date, endDate) && isSameYear(date, endDate)
    })
    : value != null
      ? value
      : null
}

export const getDebitOrCardPaymentMethod = paymentMethods => {
  let sortedPaymentMethods = []

  const cardMethods = filterPaymentMethodByKey(paymentMethods, 'card_info')

  if (!cardMethods.length) return null

  const debitCards = Object.values(cardMethods).filter(
    p => p?.card_info?.is_debit_card == true,
  )

  const creditCards = Object.values(cardMethods).filter(
    p => p?.card_info?.is_debit_card == false,
  )

  sortedPaymentMethods = debitCards?.length
    ? sortingPaymentMethods(debitCards)
    : sortingPaymentMethods(creditCards)

  sortedPaymentMethods.sort((a, b) => b.created_on - a.created_on)
  return sortedPaymentMethods[0]
}

export const getEstimatedTotalAmountData = (
  amountType,
  allowedPartialPayment,
  autoPaymentAmount,
) => {
  let showEstimatedPayment = false
  let text = __('Total Balance')
  if (
    amountType?.fixed == true &&
    amountType?.variable?.allowed == false &&
    allowedPartialPayment == true
  ) {
    text = i18nUtils.currency(autoPaymentAmount, 'p:2')
  } else if (
    amountType?.fixed == true &&
    amountType.variable?.allowed == true &&
    allowedPartialPayment == true
  ) {
    text = __('Total Balance')
  } else if (
    amountType?.variable?.allowed == true &&
    amountType?.variable?.ceiling?.hidden == false &&
    amountType?.variable?.ceiling?.required == true
  ) {
    text = `${__('Total Balance')} (~${i18nUtils.currency(
      autoPaymentAmount,
      'p:2',
    )})`
    showEstimatedPayment = true
  } else if (
    amountType?.variable?.allowed == true &&
    amountType?.variable?.ceiling?.required == false
  ) {
    text = __('Total Balance')
  }
  return { text, showEstimatedPayment }
}

export const getConvienceFeeByAmountByPaymentMethod = ({
  amount,
  method,
  successCallback,
  errorCallback,
}) => {
  let convenienceFee = 0
  let maxPaymentAmount = 0
  Api.getAvailablePaymentTypes({
    amount: amount,
    is_react_dev: process.env.NODE_ENV === 'development',
    is_auto_payment: true,
  }).then(({ unavailable = [], available = [] }) => {
    if (available.length) {
      const paymentType = [...available].filter(
        paymentType => paymentType.id == method.payment_type_id,
      )

      if (paymentType.length) {
        convenienceFee = CARD_PAYMENT_TYPE_IDS.includes(method.payment_type_id)
          ? method.card_info.is_debit_card || method.card_info.is_check_card || method.card_info.is_gift_card
            ? paymentType[0].debit_fee
            : paymentType[0].fee
          : paymentType[0].fee || 0
        maxPaymentAmount = paymentType[0]?.max_payment_amount || 0
      }
      typeof successCallback == 'function' &&
        successCallback(convenienceFee, maxPaymentAmount)
    } else {
      if (
        unavailable.length &&
        [...unavailable].filter(
          paymentType => paymentType.id == method.payment_type_id,
        ).length
      ) {
        typeof errorCallback == 'function' && errorCallback()
      }
    }
  })
}

export const isCurrentMonth = ( selectedMonth ) => {
  let changedMonth = new Date(parseInt(selectedMonth))
  return changedMonth?.getMonth() == new Date().getMonth() ? true : false
}

export const formatDate = (date, format) => {
  if (!date) return ''
  return i18nUtils.datetime(new Date(date).toISOString().split('T')[0], format)
}

export const getPaymentMethod = (payment, paymentMethods, isDisplayDefaultAccount = false) => {
  let paymentMethod = 'new'
  if (payment?.card_info) {
    let method = Object.values(paymentMethods).find(
      ({ payment_type_id, card_info, id = {} }) => {
        return (
          payment_type_id === payment?.payment_type_id &&
          card_info?.name_on_card === payment?.card_info?.name_on_card &&
          card_info?.exp_month === payment?.card_info?.exp_date_month &&
          card_info?.exp_year === payment?.card_info?.exp_date_year &&
          id == payment?.customer_payment_account_id
        )
      },
    )

    if (method) paymentMethod = method.id
  } else if (payment?.bank_info) {
    let method = Object.values(paymentMethods).find(
      ({ payment_type_id, bank_info, id = {} }) => {
        return (
          payment_type_id === payment?.payment_type_id &&
          bank_info?.name_on_account ===
            payment?.bank_info?.name_on_account &&
            (isDisplayDefaultAccount
              ? bank_info?.account_number_masked === payment?.bank_info?.account_number_masked
              : bank_info?.bank_name === payment?.bank_info?.bank_name) &&
          bank_info?.routing_number === payment?.bank_info?.routing_number &&
          id == payment?.customer_payment_account_id
        )
      },
    )
    if (method) paymentMethod = method.id
  } else if (payment?.wallet_provider_id == APPLE_PAY_WALLET_PROVIDER_ID) {
    paymentMethod = PAYMENT_TYPES.APPLE_PAY.value
  }

  return paymentMethod
}
